import { CommonEnums } from 'src/app/shared/common.enums';

export class Fltr_Inst {
    fltr_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    fltrCnd: string;
    valid_Cd: string;
    fltrCndValid_Cd: string;
    dxMp_Id: number;
    persistFlg: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    error_Cd: string;
    error_Msg: string;
    prop_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.fltr_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.fltrCnd = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.fltrCndValid_Cd = "-1";
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
        this.prop_Tab_Valid_Cd = CommonEnums.defaults.CHANGE_IND_NO;
    }

    static parse(fltr_InstTmp: Fltr_Inst): Fltr_Inst {
        let fltr_Inst: Fltr_Inst = new Fltr_Inst();
        fltr_Inst.copyFrom(fltr_InstTmp);
        return fltr_Inst;
    }

    getPrimaryKey(): string {
        return this.fltr_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Fltr_Inst {
        let fltr_InstTmp: Fltr_Inst = new Fltr_Inst();

        fltr_InstTmp.fltr_Inst_Id = this.fltr_Inst_Id;
        fltr_InstTmp.nm = this.nm;
        fltr_InstTmp.description = this.description;
        fltr_InstTmp.ver = this.ver;
        fltr_InstTmp.fltrCnd = this.fltrCnd;
        fltr_InstTmp.valid_Cd = this.valid_Cd;
        fltr_InstTmp.fltrCndValid_Cd = this.fltrCndValid_Cd;
        fltr_InstTmp.dxMp_Id = this.dxMp_Id;
        fltr_InstTmp.updateBy = this.updateBy;
        fltr_InstTmp.lastUpdateBy = this.lastUpdateBy;
        fltr_InstTmp.updateDt = this.updateDt;
        fltr_InstTmp.persistFlg = this.persistFlg;
        fltr_InstTmp.error_Cd = this.error_Cd;
        fltr_InstTmp.error_Msg = this.error_Msg;
        fltr_InstTmp.prop_Tab_Valid_Cd = this.prop_Tab_Valid_Cd;

        return fltr_InstTmp;
    }

    copyFrom(fltr_InstTmp: Fltr_Inst): void {
        this.fltr_Inst_Id = fltr_InstTmp.fltr_Inst_Id;
        this.nm = fltr_InstTmp.nm;
        this.description = fltr_InstTmp.description;
        this.ver = fltr_InstTmp.ver;
        this.fltrCnd = fltr_InstTmp.fltrCnd;
        this.valid_Cd = fltr_InstTmp.valid_Cd;
        this.fltrCndValid_Cd = fltr_InstTmp.fltrCndValid_Cd;
        this.dxMp_Id = fltr_InstTmp.dxMp_Id;
        this.updateBy = fltr_InstTmp.updateBy;
        this.lastUpdateBy = fltr_InstTmp.lastUpdateBy;
        this.updateDt = fltr_InstTmp.updateDt;
        this.persistFlg = fltr_InstTmp.persistFlg;
        this.error_Cd = fltr_InstTmp.error_Cd;
        this.error_Msg = fltr_InstTmp.error_Msg;
        this.prop_Tab_Valid_Cd = fltr_InstTmp.prop_Tab_Valid_Cd;
    }

    compare(fltr_InstTmp: Fltr_Inst): string {
        let fltr_InstString: string = this.toString(false);
        let fltr_InstTmpString: string = fltr_InstTmp.toString(false);

        if (fltr_InstString != fltr_InstTmpString) {
            return fltr_InstString + ', ' + fltr_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Fltr_Inst [fltr_Inst_Id=" + this.fltr_Inst_Id + ", nm=" + this.nm + ", description=" + this.description +
            ", valid_Cd=" + this.valid_Cd + ", fltrCndValid_Cd=" + this.fltrCndValid_Cd + ", fltrCnd=" + this.fltrCnd +
            ", dxMp_Id=" + this.dxMp_Id + ", persistFlg=" + this.persistFlg + ", prop_Tab_Valid_Cd=" + this.prop_Tab_Valid_Cd;

        if (isNotCompare) {
            str += ", ver=" + this.ver + ", updateBy=" + this.updateBy + ", lastUpdateBy=" + this.lastUpdateBy + ", updateDt=" + this.updateDt +
                ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg
        }

        str += ']';

        return str;
    }
}